import React, { PropsWithChildren } from 'react'
import { CellProps } from 'react-table'
import CustomHoverTooltip from './CustomHoverTooltip'

const CellDefault = <TData extends Object>({
    cell,
}: PropsWithChildren<CellProps<TData, unknown>>) => {
    if (!cell.value) return <></>
    if (typeof cell.value !== 'string') return cell.value
    return <CustomHoverTooltip text={cell.value as string} />
}

export default CellDefault
